import AppLayout from '@/components/feature/AppLayout';
import MetricCard from './components/MetricCard';
import PipelineBoard from './components/PipelineBoard';
import RecentActivity from './components/RecentActivity';
import { mockEditions } from '@/mocks/editions';
import { mockAiStats } from '@/mocks/aiTasks';
import { mockArticles } from '@/mocks/articles';

const deadlines = [
  { label: 'Edição 14820', date: 'Hoje 18:00', urgent: true },
  { label: 'Anúncio AutoMax', date: 'Amanhã 12:00', urgent: false },
  { label: 'Edição 14821', date: '08 Abr 09:00', urgent: false },
];

export default function DashboardPage() {
  const pendingArticles = mockArticles.filter((a) => a.status === 'revisão').length;
  const activeEditions = mockEditions.filter((e) => e.status === 'em_producao').length;
  const currentEdition = mockEditions.find((e) => e.status === 'em_producao');

  return (
    <AppLayout>
      <div className="p-6 space-y-5">

        {/* Metrics Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <MetricCard icon="ri-file-text-line" value={pendingArticles} label="Artigos em Revisão" trend="+3 hoje" trendUp accent />
          <MetricCard icon="ri-newspaper-line" value={activeEditions} label="Edições em Produção" trend="no prazo" trendUp />
          <MetricCard icon="ri-robot-line" value={mockAiStats.activeNow} label="IA Processando" trend={`${mockAiStats.todayProcessed} hoje`} trendUp />
          <MetricCard icon="ri-check-double-line" value={mockAiStats.pendingReview} label="Sugestões Pendentes" />
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">

          {/* Pipeline — 2/3 */}
          <div className="lg:col-span-2">
            <PipelineBoard />
          </div>

          {/* Right Column — 1/3 */}
          <div className="space-y-4">

            {/* Current Edition */}
            {currentEdition && (
              <div className="bg-white border border-[#E0E0E0] border-t-2 border-t-[#C41230]">
                <div className="px-4 py-3 border-b border-[#E0E0E0]">
                  <h2 className="text-xs font-bold text-[#111111] font-serif uppercase tracking-wide">Edição em Produção</h2>
                </div>
                <div className="p-4">
                  <div className="flex items-start gap-3 mb-3">
                    <div className="w-14 h-20 overflow-hidden border border-[#E0E0E0] flex-shrink-0">
                      <img src={currentEdition.coverImage} alt="Capa" className="w-full h-full object-cover object-top" />
                    </div>
                    <div>
                      <p className="text-sm font-bold text-[#111111] font-serif">Edição #{currentEdition.number}</p>
                      <p className="text-xs text-[#666666] font-sans mt-0.5">{currentEdition.theme}</p>
                      <p className="text-[10px] text-[#999999] font-sans mt-1">{currentEdition.date}</p>
                      <span className="inline-block mt-1.5 text-[9px] font-bold px-2 py-0.5 bg-[#C41230] text-white font-sans uppercase tracking-wide">Em Produção</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-2 border-t border-[#E0E0E0] pt-3">
                    {[
                      { label: 'Páginas', value: currentEdition.pages },
                      { label: 'Artigos', value: currentEdition.articles },
                      { label: 'Anúncios', value: currentEdition.ads },
                    ].map((item) => (
                      <div key={item.label} className="text-center border border-[#E0E0E0] py-2">
                        <p className="text-base font-bold text-[#111111] font-serif">{item.value}</p>
                        <p className="text-[9px] text-[#999999] font-sans uppercase tracking-wide">{item.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Deadlines */}
            <div className="bg-white border border-[#E0E0E0] border-t-2 border-t-[#111111]">
              <div className="px-4 py-3 border-b border-[#E0E0E0]">
                <h2 className="text-xs font-bold text-[#111111] font-serif uppercase tracking-wide">Próximos Prazos</h2>
              </div>
              <div className="divide-y divide-[#F0F0F0]">
                {deadlines.map((d, i) => (
                  <div key={i} className="flex items-center gap-3 px-4 py-2.5">
                    <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${d.urgent ? 'bg-[#C41230]' : 'bg-[#C8C8C8]'}`}></div>
                    <div className="flex-1">
                      <p className="text-xs font-semibold text-[#111111] font-sans">{d.label}</p>
                      <p className={`text-[10px] font-sans ${d.urgent ? 'text-[#C41230] font-semibold' : 'text-[#999999]'}`}>{d.date}</p>
                    </div>
                    {d.urgent && (
                      <span className="text-[9px] font-bold text-[#C41230] border border-[#C41230] px-1.5 py-0.5 font-sans uppercase tracking-wide">Urgente</span>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* AI Status */}
            <div className="bg-[#111111] text-white border border-[#111111]">
              <div className="px-4 py-3 border-b border-white/10">
                <div className="flex items-center gap-2">
                  <i className="ri-robot-line text-white text-sm"></i>
                  <h2 className="text-xs font-bold font-serif uppercase tracking-wide">Motor de IA</h2>
                </div>
              </div>
              <div className="p-4">
                <p className="text-[10px] text-white/50 font-sans uppercase tracking-wide mb-1">Processado hoje</p>
                <p className="text-4xl font-bold font-serif text-white mb-0.5">{mockAiStats.todayProcessed}</p>
                <p className="text-[10px] text-white/40 font-sans mb-3">tarefas concluídas</p>
                <div className="w-full bg-white/10 h-1 mb-1">
                  <div className="bg-white h-1 transition-all" style={{ width: `${mockAiStats.avgConfidence}%` }}></div>
                </div>
                <p className="text-[10px] text-white/40 font-sans">{mockAiStats.avgConfidence}% confiança média</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <RecentActivity />

          {/* Editions Overview */}
          <div className="bg-white border border-[#E0E0E0]">
            <div className="px-5 py-3 border-b-2 border-[#111111] flex items-center justify-between">
              <h2 className="text-sm font-bold text-[#111111] font-serif uppercase tracking-wide">Edições Recentes</h2>
              <button className="text-[11px] text-[#C41230] font-semibold font-sans cursor-pointer hover:underline">Ver todas</button>
            </div>
            <div className="divide-y divide-[#F0F0F0]">
              {mockEditions.map((ed) => (
                <div key={ed.id} className="flex items-center gap-3 px-5 py-3 hover:bg-[#F8F8F8] cursor-pointer transition-colors">
                  <div className="w-10 h-14 overflow-hidden border border-[#E0E0E0] flex-shrink-0">
                    <img src={ed.coverImage} alt="" className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-bold text-[#111111] font-serif">Edição #{ed.number}</p>
                    <p className="text-[11px] text-[#666666] font-sans truncate">{ed.theme}</p>
                    <p className="text-[10px] text-[#999999] font-sans">{ed.date}</p>
                  </div>
                  <span className={`text-[9px] font-bold px-2 py-0.5 font-sans uppercase tracking-wide border ${
                    ed.status === 'publicado'
                      ? 'border-[#1a7a1a] text-[#1a7a1a]'
                      : ed.status === 'em_producao'
                      ? 'border-[#C41230] text-[#C41230]'
                      : 'border-[#999999] text-[#999999]'
                  }`}>
                    {ed.status === 'publicado' ? 'Publicado' : ed.status === 'em_producao' ? 'Em Produção' : 'Planejado'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
